/**
 * Global flag indicating a design is being loaded from the backend.
 * Middlewares check this to avoid marking the design as dirty during load.
 */
let isLoadingDesign = false;

export const setIsLoadingDesign = (value: boolean): void => {
  isLoadingDesign = value;
};

export const getIsLoadingDesign = (): boolean => isLoadingDesign;
